import { Component } from "react";
import { reloadOnceIfStale } from "@/lib/staleReload";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI crash:", error, info); reloadOnceIfStale(error); }
  componentDidUpdate(prev) { if (prev.location !== this.props.location && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center" data-testid="error-boundary">
        <h2 className="font-display text-2xl font-semibold">Une erreur d'affichage est survenue</h2>
        <p className="max-w-md text-sm text-muted-foreground">{String(this.state.error?.message || this.state.error)}</p>
        <div className="flex gap-2">
          <button type="button" onClick={() => this.setState({ error: null })} className="rounded-md border px-4 py-2 text-sm" data-testid="error-retry">Réessayer</button>
          <button type="button" onClick={() => window.location.reload()} className="rounded-md bg-[#059669] px-4 py-2 text-sm text-white" data-testid="error-reload">Recharger la page</button>
        </div>
      </div>
    );
  }
}
